"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = exports.Radio = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_1 = require("./styled");
const RadioContext = (0, react_1.createContext)({});
exports.Radio = (0, react_1.forwardRef)((props, ref) => {
    const { className, disabled, value, children, reversed } = props, otherProps = __rest(props, ["className", "disabled", "value", "children", "reversed"]);
    const { checkedValue, onChange } = (0, react_1.useContext)(RadioContext);
    const checked = checkedValue === undefined ? undefined : value === checkedValue;
    return ((0, jsx_runtime_1.jsxs)(styled_1.StyledLabel, { className: className, disabled: disabled, reversed: reversed, children: [(0, jsx_runtime_1.jsx)(styled_1.StyledRadio, { checked, disabled, reversed, children: (0, jsx_runtime_1.jsx)(styled_1.HiddenRadio, Object.assign({}, otherProps, { checked, disabled, onChange, value, ref })) }), (0, jsx_runtime_1.jsx)(styled_1.StyledLabelText, { children: children })] }));
});
exports.Radio.displayName = 'Radio';
exports.RadioGroup = (0, react_1.forwardRef)((props, ref) => {
    const { value, fullWidth, onChange, children, className, inline } = props;
    const [checkedValue, setCheckedValue] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        if (props.value)
            setCheckedValue(props.value);
    }, [props.value]);
    const handleChange = (0, react_1.useCallback)((event) => {
        setCheckedValue(event.target.value);
        if (onChange)
            onChange(event);
    }, [onChange]);
    return ((0, jsx_runtime_1.jsx)(styled_1.StyledRadioGroup, { ref: ref, className: className, fullWidth: fullWidth, inline: inline, children: (0, jsx_runtime_1.jsx)(RadioContext.Provider, { value: { checkedValue, onChange: handleChange }, children: children }) }));
});
exports.RadioGroup.displayName = 'RadioGroup';
